export default {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen
}
